(function () {
/*
 * ------------------------------------------------------------------------------
 * SEARCH FORM (alpha)
 * ------------------------------------------------------------------------------
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * ------------------------------------------------------------------------------
 * Copyright (c) 2021-present Shopify Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, sell and/or create derivative works of the Software or any part thereof, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The rights granted above may only be exercised to develop themes that integrate or interoperate with Shopify software or services, and, if applicable, to distribute, offer for sale or otherwise make available any such themes via the Shopify Theme Store. All other uses of the Software are strictly prohibited.
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Custom elements Copyright 2021 Elkfox Co Pty Ltd - All rights reserved
 * ------------------------------------------------------------------------------
*/ if (customElements.get("search-form") === undefined) {
    class SearchForm extends HTMLElement {
        constructor(){
            super();
            if (this.getAttribute("data-predictive") === "false") return;
            this.cache = {};
            this.form = this.querySelector("form");
            this.input = this.querySelector('input[type="search"]');
            this.results = this.querySelector('[role="dialog"]');
            this.status = this.querySelector('[role="status"]');
            this.addEventListeners();
        }
        addEventListeners() {
            this.form.addEventListener("submit", this.onFormSubmit.bind(this));
            this.form.addEventListener("keyup", this.onKeyup.bind(this));
            this.form.addEventListener("keydown", this.onKeydown.bind(this));
            this.input.addEventListener("input", this.debounce((event)=>this.onChange(event), 300).bind(this));
        }
        debounce(fn, wait) {
            let t;
            return (...args)=>{
                clearTimeout(t);
                t = setTimeout(()=>fn.apply(this, args), wait);
            };
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            const searchTerm = this.getQuery();
            if (!searchTerm.length) {
                this.closeResults(true);
                return;
            }
            this.getSearchResults(searchTerm);
        }
        onFormSubmit(event) {
            if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
        }
        onKeyup(event) {
            if (!this.getQuery().length) this.closeResults(true);
            event.preventDefault();
            switch(event.code){
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "ArrowRight":
                    this.switchOption("down");
                    break;
                case "ArrowLeft":
                    this.switchOption("up");
                    break;
                case "Enter":
                    this.selectOption();
                    break;
                case "Escape":
                    this.closeResults(true);
                    break;
            }
        }
        onKeydown(event) {
            if (event.code === "ArrowUp" || event.code === "ArrowDown") event.preventDefault();
        }
        switchOption(direction) {
            if (!this.getAttribute("results")) return;
            const allResults = Array.from(this.querySelectorAll('[role="option"]'));
            const currentResult = allResults.find((result)=>result.getAttribute("aria-selected") === "true");
            const moveDown = !currentResult || allResults.indexOf(currentResult) === allResults.length - 1 ? allResults[0] : allResults[allResults.indexOf(currentResult) + 1];
            const moveUp = !currentResult || allResults.indexOf(currentResult) === 0 ? allResults[allResults.length - 1] : allResults[allResults.indexOf(currentResult) - 1];
            const nextResult = direction === "down" ? moveDown : moveUp;
            this.clearStatus();
            nextResult.setAttribute("aria-selected", true);
            nextResult.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            if (currentResult) currentResult.setAttribute("aria-selected", false);
            this.setStatus(nextResult.textContent);
            this.input.setAttribute("aria-activedescendant", nextResult.id);
        }
        selectOption() {
            this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button')?.click();
        }
        getSearchResults(searchTerm) {
            const queryKey = searchTerm.replace(" ", "-").toLowerCase();
            this.loading();
            if (this.cache[queryKey]) {
                this.renderResults(this.cache[queryKey]);
                return;
            }
            // NOTE: To do: improve adoption of form element settings for predictive searching
            let types = this.form.querySelector('[name="types"]') ? this.form.querySelector('[name="types"]').value : "product";
            // let limit_scope = this.form.querySelector('[name="limit_scope"]') ? this.form.querySelector('[name="limit_scope"]').value : 'all';
            // console.log(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${encodeURIComponent(types)}&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search-results`)
            console.log(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=${encodeURIComponent(types)}&${encodeURIComponent("resources[limit]")}=4&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.sku,tag&section_id=predictive-search-results`);
            fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=${encodeURIComponent(types)}&${encodeURIComponent("resources[limit]")}=4&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.sku,tag&section_id=predictive-search-results`).then((response)=>{
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.closeResults();
                    throw error;
                }
                return response.text();
            }).then((text)=>{
                const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search-results").innerHTML;
                this.cache[queryKey] = resultsMarkup;
                this.renderResults(resultsMarkup);
            }).catch((error)=>{
                this.closeResults();
                throw error;
            });
        }
        loading() {
            this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
            this.setStatus(this.loadingText);
            this.setAttribute("loading", true);
            this.status.hidden = false;
        }
        clearStatus() {
            this.status.setAttribute("aria-hidden", "true");
            this.status.textContent = "";
        }
        setStatus(statusText) {
            this.status.setAttribute("aria-hidden", "false");
            this.status.textContent = statusText;
            setTimeout(()=>{
                this.clearStatus();
            }, 1000);
        }
        renderResults(resultsMarkup) {
            this.results.innerHTML = resultsMarkup;
            this.setAttribute("results", true);
            this.updateStatus();
            this.openResults();
            this.results.querySelector("button").addEventListener("click", this.submitForm.bind(this));
        }
        updateStatus() {
            this.removeAttribute("loading");
            this.setStatus(this.querySelector("[data-predictive-search-count]").textContent);
        }
        openResults() {
            this.results.hidden = false;
            this.results.setAttribute("open", true);
            this.input.setAttribute("aria-expanded", true);
        }
        clearForm() {
            this.input.value = "";
            this.removeAttribute("results");
            this.results.hidden = true;
        }
        closeResults(clearSearchTerm = false) {
            if (clearSearchTerm) this.clearForm();
            this.querySelector('[aria-selected="true"]')?.setAttribute("aria-selected", false);
            this.input.setAttribute("aria-activedescendant", "");
            this.input.setAttribute("aria-expanded", false);
            this.results.removeAttribute("open");
            this.results.removeAttribute("style");
            setTimeout(()=>{
                this.results.innerHTML = "";
            }, 500);
        }
        submitForm() {
            this.form.submit();
        }
    }
    customElements.define("search-form", SearchForm);
}



})();
